// Admin Auth Service
// Einfaches System mit localStorage

const ADMIN_PASSWORD = 'admin123'; // In Produktion würde das über Backend validiert
const ADMIN_TOKEN_KEY = 'dichtlicht_adminToken';

export const AdminAuth = {
  // Admin Login
  login: (password) => {
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem(ADMIN_TOKEN_KEY, 'true');
      return true;
    }
    return false;
  },

  // Admin Logout
  logout: () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
  },

  // Check ob Admin
  isAdmin: () => {
    return localStorage.getItem(ADMIN_TOKEN_KEY) === 'true';
  },

  // Get Admin Token für API Calls
  getToken: () => {
    return localStorage.getItem(ADMIN_TOKEN_KEY) || null;
  }
};

export default AdminAuth;
